import { newRequest } from "./complexRequest"
import { ComplexRequestOption, ResponseType } from "./type"

// 创建房间
export const createRoom = async (
  data?: { auto_session: boolean, } & any,
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/group/create',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 复制/进入公开群组（搜索结果点击进群）：返回会话与 chat 信息
export const copyGroup = async (
  data: { id: number, robot_id?: number },
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<{
    session_id: number
    chat_id: string
    group_id?: number
    group_sn?: string
  }>>({
    url: '/client/group/copy',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 获取关联机器人
export const getRelationRobot = async (
  params?: { page: number, page_size: number } & any,
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/session/relation',
    params,
    ...option
  }, useFetch)
}



// 设置房间信息
export const setRoomInfo = async (
  data?: {
    group_name?: string
    group_scene?: string
    group_sn: string
    robots?: number[]
    users?: number[]
  } & any,
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/group/setting',
    data,
    method: 'post',
    ...option
  }, useFetch)
}


// 添加成员
export const addGroupMember = async (
  data?: {
    group_sn: string
    robots?: number[]
    users?: number[]
  },
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/group/user/add',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 

// 离开群组
export const leaveGroup = async (
  data?: {
    group_sn: string
    robots?: number[]
    users?: number[]
  },
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/group/user/del',
    data,
    method: 'post',
    ...option
  }, useFetch)
}